import React from "react";
import { useMsal } from "@azure/msal-react";
import LogoutIcon from "@mui/icons-material/Logout";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import styles from "./SignOutButton.module.scss";

const SignOutButton: React.FC = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: `${window.location.origin}`,
    }).catch((error) => {
    console.error("Logout error:", error);
  });;
  };

  return (
    <Tooltip title="Sign out">
      <IconButton onClick={handleLogout} >
        <LogoutIcon  className={styles.button}>
          Sign Out
        </LogoutIcon>
      </IconButton>
    </Tooltip>
  );
};

export default SignOutButton;
